import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { WgisService } from '../../wgis.service';
import { BaseEngine } from '../../wgis.utils';

@Component({
  selector: 'app-list-layers',
  templateUrl: './list-layers.component.html',
  styleUrls: ['./list-layers.component.css']
})
export class ListLayersComponent implements OnInit{
  
  @ViewChild('list_layers', {static: false}) list_layers;

  open = false;

  engines = [];

  subscriptionEngines: Subscription;
  subscriptionClickOut: Subscription;

  constructor(
    private eRef: ElementRef,
    private wgisservice: WgisService,
    private zone: NgZone
  ) { }

  ngOnInit() {
    this.engines = this.wgisservice.getEngines();
    // console.log(this.engines)
  }

  toggle(){
    if(!this.open){
      event.stopPropagation();
      this.subscribeClickOut();
    } else {
      this.unsubscribeClickOut();
    }
    this.open = !this.open;
  }

  subscribeChangeEngine(){
    this.subscriptionEngines = this.wgisservice.wgisEngines.subscribe((engines) => {
      this.engines = engines;
    })
  }

  switch(engine: BaseEngine){
    // console.log("Switch engine",engine);
    engine.turn(!engine.isOn);
  }

  subscribeClickOut(){
    this.subscriptionClickOut = fromEvent(document, 'click').subscribe((ev) => {
      // console.log("click");
      if(!this.list_layers.nativeElement.contains(ev.target)) {
        this.zone.run(() => {
          this.open = false;
          this.unsubscribeClickOut();
        })
      }
    })
  }

  unsubscribeClickOut(){
    if(this.subscriptionClickOut){
      this.subscriptionClickOut.unsubscribe();
      this.subscriptionClickOut = null;
    }
  }

}
